import AOS from 'aos'

/**
 *  Animation On Scroll [ReadMe.md] can be found at :
 *  • https://github.com/michalsnik/aos
 *  • TechDivision.NodeTypes/Resources/Private/Scss/Plugins/Libs/AnimateOnScroll/README.md
 *
 *
 * Controls the behaviour of AnimateOnScrollInitializer
 *
 *
 * @type {AnimateOnScrollInitializer
 */
export class AnimateOnScrollInitializer {
    constructor() {
        this.body = document.querySelector('body')
        this.disableMobile = this.body.dataset.animateOnScrollDisableMobile === 'true'
        this.onlyOnce = this.body.dataset.animateOnScrollOnlyOnce === 'true'
        this.init()
    }

    /**
     * Initializes the interactions
     */
    init() {
        if (this.disableMobile) {
            // Global settings
            // AOS will generate default data attributes on <body> Tag: [data-aos-easing="ease"] [data-aos-duration="400"] [data-aos-delay="0"]
            AOS.init({
                disable: 'mobile',
                once: this.onlyOnce, // whether animation should happen only once - while scrolling down
            })
        } else {
            // Global settings
            // AOS will generate default data attributes on <body> Tag: [data-aos-easing="ease"] [data-aos-duration="400"] [data-aos-delay="0"]
            AOS.init({
                once: this.onlyOnce, // whether animation should happen only once - while scrolling down
            })
        }
    }
}
